// App.js — Flasher single-page long-scroll with anchored sections.
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavBar from './Views/NavBar';
import HomePage from './Views/HomePage';
import DominionProject from './Views/DominionProject';
import BCAPage from './Views/BCAPage';
import WorkAroundPage from './Views/WorkAroundPage';
import RingmasterPage from './Views/RingmasterPage';
import BuildDetailPage from './Views/BuildDetailPage';
import HowIThinkPage from './Views/HowIThinkPage';
import './design-tokens.css';

function BackdropLayers() {
  return (
    <>
      <div className="flasher-aurora" aria-hidden="true">
        <div className="blob b1" />
        <div className="blob b2" />
        <div className="blob b3" />
      </div>
      <div className="flasher-spotlight" aria-hidden="true" />
      <div className="flasher-grain" aria-hidden="true" />
    </>
  );
}

function App() {
  // Set body data attributes for motion + theme so reduced-motion CSS hooks work.
  useEffect(() => {
    document.body.dataset.theme = 'lumen';
    document.body.dataset.motion = 'full';

    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => {
      document.body.dataset.motion = mq.matches ? 'reduced' : 'full';
    };
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  // Mouse-track spotlight via CSS vars on :root.
  useEffect(() => {
    let raf = null;
    let pendingX = 0;
    let pendingY = 0;
    const onMove = (e) => {
      if (document.body.dataset.motion === 'reduced') return;
      pendingX = e.clientX;
      pendingY = e.clientY;
      if (raf) return;
      raf = requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--mx', `${pendingX}px`);
        document.documentElement.style.setProperty('--my', `${pendingY}px`);
        raf = null;
      });
    };
    window.addEventListener('mousemove', onMove, { passive: true });
    return () => {
      window.removeEventListener('mousemove', onMove);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <Router>
      <BackdropLayers />
      <div className="App" style={{ position: 'relative', zIndex: 2 }}>
        <NavBar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/builds" element={<HomePage scrollTo="builds" />} />
          <Route path="/products" element={<HomePage scrollTo="products" />} />
          <Route path="/how-i-think" element={<HomePage scrollTo="how" />} />
          <Route path="/work-with-me" element={<HomePage scrollTo="work" />} />
          <Route path="/who-i-am" element={<HomePage scrollTo="about" />} />
          <Route path="/contact" element={<HomePage scrollTo="contact" />} />
          <Route path="/how-i-think-detail" element={<HowIThinkPage />} />
          <Route path="/dominion-project" element={<DominionProject />} />
          <Route path="/BCA" element={<BCAPage />} />
          <Route path="/builds/:slug" element={<BuildDetailPage />} />
          <Route path="/workaround" element={<WorkAroundPage />} />
          <Route path="/ringmaster" element={<RingmasterPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
